import { Dropdown } from "react-bootstrap"

export const GenericLinks = ({ items }) => (
    <div onClick={(e) => e.stopPropagation()}>
        <Dropdown>
            <Dropdown.Toggle variant="link" className="caret-off text-muted py-0">
                <i className="fas fa-ellipsis-v" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {items.map((item) => (
                    <Dropdown.Item key={item.text} onClick={item.onClick}>
                        {item.text}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    </div>
)
